export const useSortCustomAttributes = () => {
  const sortCustomAttributes = (customAttributes) => customAttributes.sort((a, b) => a.key.toLowerCase().localeCompare(b.key.toLowerCase()))
  return sortCustomAttributes
}